import { Box, Flex } from "@chakra-ui/layout";
import { TipoUnidadePessoaEnum } from "core/features/unidades/typings/unidade";
import { Control, UseFormWatch } from "react-hook-form";
import ShadowSelectableButton from "components/Button/ShadowSelectableButton";
import Field from "components/Input/Field";

interface FormTipoUnidade {
  tipoUnidadePessoaId?: TipoUnidadePessoaEnum | null;
}
interface FormTipoProps<T extends FormTipoUnidade> {
  control: Control<T>;
  watch: UseFormWatch<T>;
  trigger: () => any;
}

function FormTipo<T extends FormTipoUnidade>({
  control,
  watch,
  trigger,
}: FormTipoProps<T>) {
  const form = watch();

  const tipoUnidadePessoaId = form?.tipoUnidadePessoaId;

  const options = [
    {
      label: "Proprietário",
      type: TipoUnidadePessoaEnum.Proprietario,
    },
    {
      label: "Co-proprietário",
      type: TipoUnidadePessoaEnum.CoProprietario,
    },
    {
      label: "Sócio",
      type: TipoUnidadePessoaEnum.Socio,
    },
    {
      label: "Locatário",
      type: TipoUnidadePessoaEnum.Locatario,
    },
    {
      label: "Outros",
      type: TipoUnidadePessoaEnum.Outros,
    },
  ];

  return (
    <Box mb={6}>
      <Field
        control={control}
        name="tipoUnidadePessoaId"
        rules={{ required: "Campo obrigatório" }}
        render={({ field }) => (
          <Flex gap={"16px"} justifyContent="space-between" flexFlow="row wrap">
            {options.map((option, index) => (
              <Flex key={index} flex={1}>
                <ShadowSelectableButton
                  px={1}
                  width="100%"
                  selected={tipoUnidadePessoaId === option.type}
                  onClick={() => {
                    field.onChange(option.type);
                    trigger();
                  }}
                >
                  {option.label}
                </ShadowSelectableButton>
              </Flex>
            ))}
          </Flex>
        )}
      />
    </Box>
  );
}

export default FormTipo;
